import './App.css';
import { useState, useEffect } from "react";
import { Route, Routes } from 'react-router-dom';
import ProjectTable from './components/ProjectTable';
import MenuBar from './components/MenuBar';
import LandingPage from './components/LandingPage';
import { useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import SearchBar from './components/SearchBar';
import Contact from './components/Contact';
import About from './components/About';
import Help from './components/Help';


function App() {
  const [filterPrice, setFilterPrice] = useState('');
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [type, setType] = useState('');
  const [minSize, setMinSize] = useState('');
  const [district, setDistrict] = useState('');
  const [minYear, setMinYear] = useState('');
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);

    fetch(`https://qidyy-home-forwarder.dinhtran-dev.workers.dev/projects?lat=10.76&lng=106.66&type=${type}&maxPrice=${filterPrice}`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then(data => {
        console.log("API response data", data);
        setProjects(data.projects);
        setIsLoading(false);
      })
      .catch(err => {
        console.error("API error", err);
        setError("Something went wrong while fetching projects.");
        setIsLoading(false);
      });
  }, [filterPrice, type]);

  return (
    <div className="app-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        position: 'relative',
      }}>
      <MenuBar isLandingPage={location.pathname === '/'} />
      <div style={{
        flex: 1,
        paddingTop: location.pathname === '/' ? '0' : '110px'
      }}> {
          <Routes>
            <Route path="/" index={true} element={<LandingPage />} />
            <Route path="/projects" element={
              <div className="main-content">
                <div className="sidebar-container">
                  <div className="filters">
                    <SearchBar
                      filterPrice={filterPrice}
                      onFilterPriceChange={setFilterPrice}
                      type={type}
                      onTypeChange={setType}
                      minSize={minSize}
                      onMinSizeChange={setMinSize}
                      district={district}
                      onDistrictChange={setDistrict}
                      minYear={minYear}
                      onMinYearChange={setMinYear}
                    />
                  </div>
                </div>


                <div className='results'>
                  {error && <p className="error">{error}</p>}
                  {isLoading ? (
                    <p>Loading...</p>
                  ) : (
                    <ProjectTable
                      filterPrice={filterPrice}
                      projects={projects}
                      type={type}
                      minSize={minSize}
                      district={district}
                      minYear={minYear}
                    />
                  )}
                </div>
              </div>
            } />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/help" element={<Help />} />
          </Routes>}
      </div>
      <Footer isLandingPage={location.pathname === '/'} />
    </div>
  );
}

export default App;